import React from 'react'
import { observer } from 'mobx-react-lite'
import StatusRoadmapView from 'pages/ApplicationsPage/components/StatusRoadmap/StatusRoadmapView'
import BragsheetSection from './components/BragsheetSection/BragsheetSection'
import ApplicationRecommendationCard from './components/ApplicationRecommendationCard/ApplicationRecommendationCard'
import RecommendationsSkeleton from './components/RecommendationsSkeleton/RecommendationsSkeleton'
import useStudentRecommendationsTab from './hooks/useStudentRecommendationsTab'
import s from './styles/StudentRecommendationsTab.module.scss'

const StudentRecommendationsTab = observer(
	({ studentId = null, studentName = 'Student', isActive = false }) => {
		const {
			loadStatus,
			error,
			bragsheetRows,
			applicationCards,
			filters,
			hasLoadedOnce,
			reload,
		} = useStudentRecommendationsTab(studentId, isActive)

		const showSkeleton =
			!hasLoadedOnce && (loadStatus === 'idle' || loadStatus === 'loading')

		if (showSkeleton) {
			return <RecommendationsSkeleton />
		}

		if (error) {
			return <div className={s.error}>{error}</div>
		}

		return (
			<div className={s.wrap}>
				<BragsheetSection
					studentId={studentId}
					studentName={studentName}
					rows={bragsheetRows}
					onReload={reload}
				/>

				{filters.totalCount ? (
					<section className={s.applications}>
						<div className={s.sectionHeading}>
							<div>
								<h3>Application letters</h3>
								<p>Track requests and manage letters by university.</p>
							</div>
							<span className={s.count}>{applicationCards.length}</span>
						</div>
						<div className={s.filters}>
							<StatusRoadmapView {...filters} />
						</div>
						<div className={s.table} role="table" aria-label="Application letters">
							<div className={s.tableHeader} role="row">
								<span role="columnheader">Application</span>
								<span role="columnheader">Request status</span>
								<span role="columnheader">Letters written</span>
								<span role="columnheader">Actions</span>
							</div>
							<div role="rowgroup">
								{applicationCards.map(card => (
									<ApplicationRecommendationCard
										key={card.applicationTargetId}
										card={card}
										studentId={studentId}
										studentName={studentName}
										onReload={reload}
									/>
								))}
							</div>
						</div>
					</section>
				) : null}

				{!filters.totalCount ? (
					<div className={s.emptyApps}>No applications found for this student.</div>
				) : null}
			</div>
		)
	},
)

export default StudentRecommendationsTab
